import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getServiceTechnicians = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/service_technicians', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getServiceTechnician = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/service_technicians/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeServiceTechnician = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/service_technicians', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateServiceTechnician = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/service_technicians/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteServiceTechnician = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/service_technicians/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchServiceTechnicians = async (term, token) => (
	fetch( getDomain()+`/service_technicians?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)